<div class="pure-avatar-wrapper" [ngClass]="type">
    <span *ngIf="type === 'user'" class="pure-avatar-letter">{{ firstLetter }}</span>
    <span *ngIf="type === 'support'" class="pure-avatar-support">
        <pureui-svg svg="avatar-support.svg" [height]="height"></pureui-svg>
    </span>
    <span *ngIf="type === 'unknown'" class="pure-avatar-unknown">
        <pureui-svg svg="avatar-unknown.svg" [height]="height"></pureui-svg>
    </span>
</div>
